import React from 'react';
import {useTranslation} from 'react-i18next';

import Button from '../common/Button';
import {TopBarBlock, LeftSide, RightSide} from '../common/MainBlocks';
import TabLinkGroup from '../common/TabLinkGroup';
import TabLink from '../common/TabLink';

import SearchForm from './SearchForm';
import RefreshButton from './RefreshButton';
import ChangeTariffsIcon from "../icons/ChangeTariffsIcon";
import PlusIcon from "../icons/PlusIcon";

const Topbar = () => {
  const {t} = useTranslation();

  return (
    <TopBarBlock fixed white>
      <LeftSide>
        <TabLinkGroup>
          <TabLink
            to="/locations">
            {t('allLocations')}
          </TabLink>
        </TabLinkGroup>
      </LeftSide>
      <RightSide>
        <SearchForm/>
        <Button
          to="/locations/add"
          theme="blue"
          minWidth="none"
          height="40px"
          margin="0"
          title="Добавить новую локацию">
            <PlusIcon />
        </Button>

        <Button
          to="/locations/tariffs"
          theme="blue"
          minWidth="none"
          height="40px"
          margin="0 18px 0 18px"
          title="Изменить тарифы"
        >
            <ChangeTariffsIcon />
        </Button>

        <RefreshButton/>
      </RightSide>
    </TopBarBlock>
  );
};

export default Topbar;
